module.exports = __webpack_public_path__ + "static/img/member_saskia.7bc82e31.jpg";